module.exports = __webpack_public_path__ + "img/qiyeweixin.d72e999a.png";